import { render, staticRenderFns } from "./xm_pg_Traffic.vue?vue&type=template&id=521dd198"
import script from "./xm_pg_Traffic.vue?vue&type=script&lang=js"
export * from "./xm_pg_Traffic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports